import { useEffect, useState } from 'react';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';
import { db } from '../lib/firebase';
import type { Message } from '../lib/types';

export function useMessages(chatId: string | null): { messages: Message[]; loading: boolean } {
  const [messages, setMessages] = useState<Message[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!chatId) {
      setMessages([]);
      setLoading(false);
      return;
    }
    const q = query(collection(db, 'chats', chatId, 'messages'), orderBy('createdAt', 'asc'));
    const unsub = onSnapshot(
      q,
      (snap) => {
        setMessages(snap.docs.map((d) => ({ id: d.id, ...(d.data() as Omit<Message, 'id'>) })));
        setLoading(false);
      },
      (err) => {
        console.error('useMessages listener error', err);
        setLoading(false);
      }
    );
    return unsub;
  }, [chatId]);

  return { messages, loading };
}
